import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

export default function UnauthenticatedRoute({ children, ...rest }) {
  const authentication = useSelector((state) => state.authentication);
  const { isSignedIn } = authentication;
  const userData = useSelector((state) => state.user);
  const { user } = userData;

  return <Route {...rest}>{!isSignedIn || !user ? children : <Redirect to="/recordings" />}</Route>;
}
